import { HebrewDateFormatter, JewishCalendar } from 'kosher-zmanim';

/**
 * The Jewish holiday — or, failing one, Rosh Chodesh — that a civil day falls
 * on, as the date pickers print it under the day: '' for an ordinary day.
 *
 * One source for every calendar that shows holidays (Jewish_Date_Picker and
 * the screen schedule's range calendar), so two pickers open side by side can
 * never disagree about what a day is.
 */

// kosher-zmanim's Hebrew names carry niqqud, which is noise at the few pixels
// a calendar cell gives them.
const stripNiqqud = (label: unknown): string => String(label || '')
  .normalize('NFKD')
  .replace(/[֑-ׇ]/g, '')
  .trim();

export interface HolidayLabelOptions {
  /** The Israeli calendar: one day of Yom Tov, no second-day holidays. */
  inIsrael?: boolean;
  /** Hebrew names ('ראש השנה'), else transliterated ones ('Rosh Hashana'). */
  hebrew?: boolean;
}

export const jewishHolidayLabel = (
  date: Date | null | undefined,
  { inIsrael = false, hebrew = true }: HolidayLabelOptions = {}
): string => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  try {
    const calendar = new JewishCalendar(date);
    calendar.setInIsrael(inIsrael);
    calendar.setUseModernHolidays(true);

    const formatter = new HebrewDateFormatter();
    formatter.setHebrewFormat(hebrew);

    const holiday = formatter.formatYomTov(calendar);
    if (holiday) return stripNiqqud(holiday);
    if (calendar.isRoshChodesh()) return stripNiqqud(formatter.formatRoshChodesh(calendar));
  } catch (error) {
    return '';
  }
  return '';
};
